import React from 'react'

import { Icon } from '@iconify/react'
import home5Fill from '@iconify/icons-ri/home-5-fill'
import bracesFill from '@iconify/icons-ri/braces-fill'
import user4Fill from '@iconify/icons-ri/user-4-fill'
import mailFill from '@iconify/icons-ri/mail-fill'

import useResponsive from '../hooks/useResponsive'

export default (props) => {

  const { untilWidescreen, isMobileMenu } = useResponsive()

  return (
    <ul className="sideNav__menu menu" role="menu">
      <li className="menu__item">
        <button onClick={() => props.anchorScrollTo('#app')} className="menu__link is-link-button">
          <Icon icon={home5Fill} width={untilWidescreen ? 32 : 24} />
          {isMobileMenu && <div className="menu__label">Accueil</div>}
          {!isMobileMenu && <div className="is-sr-only">Accueil</div>}
        </button>
      </li>
      <li className="menu__item">
        <button onClick={() => props.anchorScrollTo('#projects-anchor')} className="menu__link is-link-button">
          <Icon icon={bracesFill} width={untilWidescreen ? 32 : 24} />
          {isMobileMenu && <div className="menu__label">Projets</div>}
          {!isMobileMenu && <div className="is-sr-only">Projets</div>}
        </button>
      </li>
      <li className="menu__item">
        <button onClick={() => props.anchorScrollTo('#about-anchor')} className="menu__link is-link-button">
          <Icon icon={user4Fill} width={untilWidescreen ? 32 : 24} />
          {isMobileMenu && <div className="menu__label">A propos</div>}
          {!isMobileMenu && <div className="is-sr-only">A propos</div>}
        </button>
      </li>
      <li className="menu__item">
        <button onClick={() => props.anchorScrollTo('max')} className="menu__link is-link-button">
          <Icon icon={mailFill} width={untilWidescreen ? 32 : 24} />
          {isMobileMenu && <div className="menu__label">Me contacter</div>}
          {!isMobileMenu && <div className="is-sr-only">Me contacter</div>}
        </button>
      </li>
    </ul>
  )
}